export type AuthUser = {
  id: string;
  username: string;
  email: string;
};

type AuthResponse = {
  success?: boolean;
  authenticated?: boolean;
  user?: AuthUser | null;
  error?: string;
};

async function request(path: string, options: RequestInit = {}): Promise<AuthResponse> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });

  let data: AuthResponse = {};
  try {
    data = await res.json();
  } catch {
    data = { error: 'Invalid server response' };
  }

  if (!res.ok) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }
  return data;
}

export const authService = {
  async me(): Promise<AuthUser | null> {
    try {
      const data = await request('/api/auth/me', { method: 'GET' });
      return data.authenticated && data.user ? data.user : null;
    } catch {
      return null;
    }
  },

  async signup(username: string, email: string, password: string): Promise<AuthUser> {
    const data = await request('/api/auth/signup', {
      method: 'POST',
      body: JSON.stringify({ username, email, password }),
    });
    if (!data.user) throw new Error(data.error || 'Signup failed');
    return data.user;
  },

  async login(usernameOrEmail: string, password: string): Promise<AuthUser> {
    const data = await request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ usernameOrEmail, password }),
    });
    if (!data.user) throw new Error(data.error || 'Login failed');
    return data.user;
  },

  async logout(): Promise<void> {
    await request('/api/auth/logout', { method: 'POST', body: '{}' });
  },
};